import React from 'react';
import { NavLink } from 'react-router-dom';
import "./Sidebar.scss"
import { selectUserType } from '../../../redux/features/auth/authSlice';
import { useSelector } from 'react-redux';


const SidebarItems = ({ item, isOpen, onNavigate }) => {
  const activeLink = ({ isActive }) => (isActive ? "active" : "");
  const isActive   = window.location.pathname === item.path;
  const userType   = useSelector(selectUserType);
  const renderReports = userType === "admin";

  const handleClick = () => {
    if (onNavigate) onNavigate();
  };

  if (renderReports) {
    return (
      <NavLink
        to={item.path} className={activeLink}
        style={{ color: isActive ? "blue" : "black", textDecoration: "none" }}
        onClick={handleClick}>
        <div className="sidebar-item">
          <div className="sidebar-title">
            <span>
              {item.icon && <div className="icon">{item.icon}</div>}
              {isOpen && <div className="title">{item.title}</div>}
            </span>
          </div>
        </div>
      </NavLink>
    );
  }

  if (
    item.title !== "Reports" &&
    item.title !== "Users" &&
    item.title !== "Dashboard" &&
    item.title !== "User Management" &&
    item.title !== "Product Stock Batches" &&
    item.title !== "Stock Adjustment" &&
    item.title !== "Sale Returns" &&
    item.title !== "Shift Closing"
  ) {
    return (
      <NavLink
        to={item.path} className={activeLink}
        style={{ color: isActive ? "blue" : "black", textDecoration: "none" }}
        onClick={handleClick}>
        <div className="sidebar-item">
          <div className="sidebar-title">
            <span>
              {item.icon && <div className="icon p-0">{item.icon}</div>}
              {isOpen && <div className="title p-0">{item.title}</div>}
            </span>
          </div>
        </div>
      </NavLink>
    );
  }

  return null;
};

export default SidebarItems;
